import { render, staticRenderFns } from "./communicationLogDetialPop.vue?vue&type=template&id=1063bae0"
import script from "./communicationLogDetialPop.vue?vue&type=script&lang=js"
export * from "./communicationLogDetialPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports